import React from 'react';

import { Box, HStack, Skeleton, SkeletonCircle } from '@wegroup/design-system';

const AssistantQuestionSkeleton: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <HStack spacing="9" mb="8" alignItems="flex-start">
      <SkeletonCircle w="20" h="20" flexShrink={0} />
      <Box w="100%">
        <Skeleton w="16" h="5" borderRadius="full" mt="4" mb="2" />
        <Skeleton w="75%" h="8" mb="1" />
        <Skeleton w="50%" h="8" />
      </Box>
    </HStack>
  );
};

export default AssistantQuestionSkeleton;
